<template>
  <div>
    <el-row style="margin: 20px auto">
      <el-col :xl="4" :lg="4" :md="6">
        <span>订单日期：{{SEND_DAY}}</span>
      </el-col>
      <el-col :xl="6" :lg="8" :md="12">
        <span>项目点：{{ PROJECT_NAME }}</span>
      </el-col>
      <el-col :xl="3" :lg="4" :md="6">
        <span>档口：{{DK_NAME}}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-table :data="tableData" border stripe>
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
        <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
        <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
        <el-table-column prop="PRODUCT_COUNT" label="订购数量"></el-table-column>
        <el-table-column prop="DELIVER_PRODUCT_CODE" label="出库产品编码"></el-table-column>
        <el-table-column prop="DELIVER_PRODUCT_NAME" label="出库产品名称"></el-table-column>
        <el-table-column prop="DELIVER_TYPE_UNIT" label="单位"></el-table-column>
        <el-table-column prop="BATCH" label="批次"></el-table-column>
        <el-table-column prop="DELIVER_COUNT" label="出库数量"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="openAllEdit(scope.row)">调整</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <el-col :span="2" :offset="22" style="margin-top: 24px">
        <el-button size="small" type="default" @click="matchItem">匹配</el-button>
      </el-col>
    </el-row>
    <!-- <el-row>
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
    </el-row> -->
    <el-dialog title="修改全部信息" center :visible.sync="editAllFormVisible" width="900px">
      <el-row style="margin-top: 20px">
        <el-form :model="searchForm" ref="searchForm" :inline="true" size="small">
          <el-form-item label="出库日期：">
            <el-date-picker v-model="searchForm.SEND_DAY" value-format="yyyy-MM-dd" type="date" @change="doQueryTable()" placeholder="选择日期"
              :clearable="true">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="项目点：">
            <label slot="label">项&nbsp;目&nbsp;&nbsp;点：{{ PROJECT_NAME }}</label>
          </el-form-item>
          <el-form-item label="产品名称：">
            <el-input v-model="searchForm.PRODUCT_NAME" @blur="doQueryTable()"></el-input>
          </el-form-item>
          <!-- <el-form-item>
            <el-button @click="doQueryTable()" >筛选</el-button>
          </el-form-item> -->
        </el-form>
      </el-row>
      <el-row>
        <el-table :data="listData" border stripe>
          <el-table-column prop="DELIVER_DAY" label="出库日期"></el-table-column>
          <el-table-column prop="PROJECT_NAME" label="项目点"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="BATCH" label="批次"></el-table-column>
          <el-table-column prop="DELIVER_COUNT" label="出库数量"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="selectMatch(scope.row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <!-- <div slot="footer" class="dialog-footer">
            <el-button @click="closeAll">取 消</el-button>
            <el-button @click="submitEditAll">确 定</el-button>
          </div> -->
    </el-dialog>
  </div>
</template>
<script>
// import util from '@/assets/common/util';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      listData: [],
      tableData: [],
      total_count: 0,
      editFormVisible: false,
      searchForm: {
        SEND_DAY: sessionStorage.getItem('nDM_SEND_DAY'),
      },
      DK_NAME: sessionStorage.getItem('nDM_DK_NAME'),
      SEND_DAY: sessionStorage.getItem('nDM_SEND_DAY'),
      PROJECT_NAME: sessionStorage.getItem('nDM_PROJECT_NAME'),
      PROJECT_ID: sessionStorage.getItem('nDM_PROJECT_ID'),
      ORDER_ID: sessionStorage.getItem('nDM_ORDER_ID'),
      DK_ID: sessionStorage.getItem('nDM_DK_ID'),
      RECORD_ID_LIST: JSON.parse(sessionStorage.getItem('nDM_RECORD_ID_LIST')),
      totalCount: 0,
      pageSize: 20,
      currentPage: 1,
      editAllFormVisible: false,
      editAllForm: {},
      DETAIL_DATA: [],
    };
  },
  inject: ['reload'],
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 20;
    this.queryData();
    this.queryListData();
  },
  methods: {
    // ----------------分页
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryListData();
    },
    doQueryTable() {
      this.queryData();
    },
    closeAll() {
      this.editAllFormVisible = false;
    },
    openAllEdit(row) {
      this.editAllFormVisible = true;
      this.editAllForm = row;
      this.doQueryTable();
    },
    selectMatch(row) {
      this.editAllForm.BATCH = row.BATCH;
      this.editAllForm.DELIVER_PRODUCT_CODE = row.PRODUCT_CODE;
      this.editAllForm.DELIVER_PRODUCT_NAME = row.PRODUCT_NAME;
      this.editAllForm.DELIVER_TYPE_UNIT = row.TYPE_UNIT;
      this.editAllForm.DELIVER_TYPE_UNIT = row.TYPE_UNIT;
      this.editAllForm.DELIVER_COUNT = row.DELIVER_COUNT;
      this.editAllForm.RECORD_ID = row.RECORD_ID;
      this.$message.show({ text: '操作成功', type: 'success' });
      this.editAllFormVisible = false;
    },
    matchItem() {
      this.DETAIL_DATA = this.tableData.map((item) => ({ RECORD_ID: item.RECORD_ID, DETAIL_ID: item.DETAIL_ID }));
      const params = {
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        SERVICE_ID: '10031',
        OTYPE: 89,
        ORDER_ID: this.ORDER_ID,
        DK_ID: this.DK_ID,
        DETAIL_DATA: this.DETAIL_DATA,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '操作成功', type: 'success' });

        setTimeout(() => {
          this.$router.push({ name: 'stockOut' });
        }, 500);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleSelectionChange() {},
    // 页面加载时请求的数据
    queryData() {
      const params = {
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        SERVICE_ID: '10031',
        OTYPE: 88,
        PAGE_SIZE: this.pageSize,
        PAGE_INDEX: this.currentPage - 1,
        PROJECT_ID: this.PROJECT_ID,
      };
      if (this.searchForm.SEND_DAY) {
        params.DELIVER_DAY = this.searchForm.SEND_DAY;
      }
      if (this.searchForm.PRODUCT_CODE) {
        params.PRODUCT_CODE = this.searchForm.PRODUCT_CODE;
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      http.post(params).then((result) => {
        if (result.length == 0) {
          this.listData = [];
        } else {
          this.listData = result[0].LIST;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    queryListData() {
      const params = {
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        SERVICE_ID: '10031',
        OTYPE: 90,
        PAGE_SIZE: this.pageSize,
        PAGE_INDEX: this.currentPage - 1,
        RECORD_ID_LIST: this.RECORD_ID_LIST,
        ORDER_ID: this.ORDER_ID,
      };
      http.post(params).then((result) => {
        if (result.length == 0) {
          this.tableData = [];
          this.totalCount = 0;
        } else {
          this.tableData = result;
          this.totalCount = result[0].TOTAL_COUNT;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // -------------------------------------全部确认
    allSubmit() {
      this.$router.push({ name: 'matchDocument' });
    },

  },
};
</script>
<style scoped>
.el-table .warning-row {
  background: pink;
}

.tableArea {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/warehouseManage/matchDocument.vue